import { cloneElement, type HTMLAttributes, type ReactNode } from 'react';
import { Text } from '@doist/marketist';
import cn from 'clsx';
import css from './product-ui-field.module.css';
const defaultIconProps = {
  width: 24,
  height: 24,
  color: 'var(--display-onlight-tertiary)'
};
type ProductUIFieldProps = {
  label?: string;
  startIcon?: React.ReactElement;
  endIcon?: React.ReactElement;
  children: ReactNode;
  hovered?: boolean;
  disabled?: boolean;
} & HTMLAttributes<HTMLDivElement>;
function ProductUIField({
  label,
  startIcon,
  endIcon,
  children,
  hovered,
  disabled
}: ProductUIFieldProps) {
  const StartIcon = startIcon ? cloneElement(startIcon, {
    ...defaultIconProps,
    ...startIcon.props
  }) : undefined;
  const EndIcon = endIcon ? cloneElement(endIcon, {
    ...defaultIconProps,
    ...endIcon.props
  }) : undefined;
  return <div data-sentry-component="ProductUIField" data-sentry-source-file="product-ui-field.tsx">
            {label ? <Text size="minor-sm" weight="semibold" className="mbe-12">
                    {label}
                </Text> : null}
            <div className={cn(css.field, {
      [css.hovered]: hovered,
      [css.disabled]: disabled
    })}>
                {StartIcon}
                <div className={css.children}>{children}</div>
                {EndIcon}
            </div>
        </div>;
}
export type ProductUIFieldTextProps = {
  children: React.ReactNode;
  isPlaceholder?: boolean;
};
ProductUIField.Text = function ({
  children,
  isPlaceholder,
  ...rest
}: ProductUIFieldTextProps) {
  return <Text size="body-xs" weight="medium" className={cn({
    [css.placeholder]: isPlaceholder
  })} {...rest}>
            {children}
        </Text>;
};
function ProductUIFields({
  children
}: {
  children: ReactNode;
}) {
  return <div className={css.fields} data-sentry-component="ProductUIFields" data-sentry-source-file="product-ui-field.tsx">{children}</div>;
}
export { ProductUIField, ProductUIFields };